module.exports = __webpack_public_path__ + "img/Group.eee0b755.svg";